export * from './roof-type-7.component';